import React, { useEffect, useState } from 'react';
import { Button, Card, Space, Typography } from 'antd';
import StoreSettingService from 'services/store_setting';
import { useApp } from 'contexts/app';
import { useWorkSpace } from 'contexts/workspace';

const { Paragraph, Text } = Typography;
const service = new StoreSettingService();

const FeedCenter = () => {
  const { showLoading, message } = useApp();
  const { getWebsiteUrl } = useWorkSpace();
  const [status, setStatus] = useState(null);
  const sitemapURL = getWebsiteUrl('/sitemap.xml');

  const loadData = async () => {
    showLoading(true);
    try {
      const feedStatus = await service.getSEOFeedStatus();
      setStatus(feedStatus || null);
    } catch (error) {
      message.error(error?.message || 'Không thể tải trạng thái sitemap');
    }
    showLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const openSitemap = () => {
    const nextURL = String(sitemapURL || '').trim();
    if (!nextURL) {
      message.error('Chưa có link sitemap để mở');
      return;
    }

    window.open(nextURL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Space direction="vertical" size={16} style={{ width: '100%' }}>
      <Card title="Sitemap">
        <Space direction="vertical" style={{ width: '100%' }}>
          <Paragraph copyable={!!sitemapURL}>
            <Text strong>Sitemap:</Text> {sitemapURL || '-'}
          </Paragraph>
          <Space>
            <Button type="primary" onClick={openSitemap}>Mở link sitemap</Button>
            <Button onClick={loadData}>Tải lại</Button>
          </Space>
        </Space>
      </Card>
    </Space>
  );
};

export default FeedCenter;
